export var sessionNotFoundError = function (str) {
    var regex = /[S-s]ession [a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12} not found/;
    return regex.test(str) ? str.match(regex) : false;
};
